<template>
  <v-app id="eta" light>
    <v-navigation-drawer ref="mainMenu" v-if="status" :mini-variant.sync="miniD" v-model="drawer" dark fixed clipped
      app>
      <v-list dense class>
        <template v-for="(item, index) in menuItems">
          <v-layout v-if="item.heading" :key="index" row align-center>
            <v-flex xs12>
              <v-subheader class="font-weight-bold text-uppercase mt-3" v-if="item.heading && item.display && status">
                {{
                item.heading }}
              </v-subheader>
            </v-flex>
          </v-layout>
          <v-list-tile class="my-2" v-else-if="item.avatar && item.display && status" :key="index" avatar
            @click.stop="toggleMiniDrawer()">
            <v-list-tile-avatar>
              <img :src="item.avatar" :alt="item.title">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn name="minimize" aria-label="Minimize" icon @click.stop="toggleMiniDrawer()">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile class="my-2" v-else-if="item.link && item.display && status" :key="index"
            :to="{ path: item.label}">
            <v-list-tile-avatar>
              <v-icon :class="currentPage == item.label ? 'primary--text display-1' : ''">
                {{
                item.icon }}
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title :class="currentPage == item.label ? 'primary--text' : ''">{{ item.text }}
              </v-list-tile-title>
              <!-- <v-list-tile-sub-title :class="currentPage == item.label ? 'primary--text' : ''">{{ item.description }}</v-list-tile-sub-title> -->
            </v-list-tile-content>
            <v-list-tile-action v-if="item.external">
              <!-- <v-btn :name="item.label + '-new'" :aria-label="item.label + '-new'" icon ripple :to="{ path: item.label}" target="_blank">
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>-->
              <v-btn :name="item.label + '-new'" :aria-label="item.label + '-new'" icon ripple
                @click.prevent="openInNew(item.label)">
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar v-if="status" class="elevation-5" ref="mainToolbar" color="primary" app clipped-left fixed>
      <v-toolbar-side-icon v-if="status" aria-label="Menu"
        @click.native="token == null ? drawer = false : drawer = !drawer">
        <v-icon color="accent">mdi-menu</v-icon>
      </v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <!-- <v-text-field v-if="status" class="hidden-sm-and-down" solo-inverted flat hide-details
        label="Search ... Not working yet but coming soon ^_^" single-line prepend-inner-icon="mdi-magnify">
      </v-text-field> -->
      <v-spacer></v-spacer>
      <!-- <v-btn name="translate" aria-label="Translate" v-if="status" icon @click="execute('translate')">
        <v-icon>mdi-translate</v-icon>
      </v-btn>-->
      <v-btn name="login" aria-label="Login" v-if="!status" icon @click="execute('login')">
        <v-icon>mdi-login</v-icon>
      </v-btn>
      <v-chip :disabled="true" v-if="status" class="subheading font-weight-bold elevation-0 transparent">
        <v-avatar size="36" :class="userData.image != null && userData.image != '' ? '' : 'primary lighten-3'">
          <img v-if="userData.image != null && userData.image != ''" :src="userData.image" :alt="userData.name">
          <span v-else>{{ userData.name.charAt(0).toUpperCase() }}</span>
        </v-avatar>
        <span class="hidden-sm-and-down">{{ userData.name }}</span>
      </v-chip>
      <v-tooltip bottom>
        <v-icon name="online" aria-label="online" v-if="status && (wsOnline == null)" color="grey" class="mx-2"
          slot="activator">mdi-lan-connect</v-icon>
        <v-icon name="online" aria-label="online" v-else-if="status && (wsOnline === true)" color="success" class="mx-2"
          slot="activator">mdi-lan-connect</v-icon>
        <v-icon name="online" aria-label="online" v-else-if="status && (wsOnline === false)" color="warning"
          class="mx-2" slot="activator">mdi-lan-disconnect</v-icon>
        <span v-if="wsOnline == null">Connecting to real-time server</span>
        <span v-else-if="wsOnline === true">Connected to real-time server</span>
        <span v-else-if="wsOnline === false">Not connected to real-time server</span>
      </v-tooltip>
      <v-menu v-if="status" bottom offset-y origin="center center" transition="scale-transition" style="z-index:100;">
        <template v-slot:activator="{ on }">
          <v-btn name="notification" aria-label="Notification" v-if="status" icon v-on="on" @click="newAlert = false">
            <v-badge overlap v-model="newAlert" right>
              <v-icon slot="badge" color="error" small>mdi-asterisk</v-icon>
              <v-icon color="accent">mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-list style="width:360px;max-height:360px;overflow-y:auto;" subheader dense v-if="sortedAlerts.length > 0"
          three-line>
          <template v-for="(alert, index) in sortedAlerts">
            <v-list-tile :key="`al-${index}`">
              <v-list-tile-content>
                <v-list-tile-title v-html="formatTime(alert.created)"></v-list-tile-title>
                <v-list-tile-sub-title v-html="alert.desc"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider :key="`dvdr-${index}`"></v-divider>
          </template>
        </v-list>
      </v-menu>
      <v-btn name="logout" aria-label="Logout" v-if="status" icon @click="execute('logout')">
        <v-icon color="error">mdi-logout</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content ref="mainContent" v-resize="onResize">
      <v-container fluid fill-height class="pa-0" v-scroll="onScroll">
        <router-view></router-view>
        <new-request v-if="status" :token="token" :userData="userData" :open="request" :language="language"
          :companies="companies" :vehiclesType="vehiclesType" :equipmentsType="equipmentsType"></new-request>
        <new-vehicle v-if="status" :token="token" :userData="userData" :open="vehicle" :language="language"
          :vehiclesType="vehiclesType"></new-vehicle>
        <new-employee v-if="status" :token="token" :userData="userData" :permDash="permDash"
          :permDispatches="permDispatches" :permEmployees="permEmployees" :permNotif="permNotif"
          :permPartners="permPartners" :permReq="permReq" :permTrack="permTrack" :permVeh="permVeh" :open="employee"
          :resources="resources" :permGroups="permGroups" :permissions="permissions" :language="language">
        </new-employee>
        <new-partner v-if="status" :token="token" :userData="userData" :open="partner" :language="language"
          :companies="companies" :equipmentsType="equipmentsType" :vehiclesType="vehiclesType"></new-partner>
        <v-speed-dial v-if="status && (currentPage != 'welcome')" v-model="fab" fixed :bottom="true" right
          direction="top" transition="slide-y-reverse-transition">
          <v-btn name="quickAction"
            v-if="this.permReq.create || this.permVeh.create || this.permEmployees.create || this.permPartners.create"
            aria-label="Quick Action" slot="activator" v-model="fab" color="primary" fab>
            <v-icon>mdi-plus</v-icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-tooltip left>
            <v-btn v-if="this.permReq.create" name="newServiceCall" aria-label="New Service Call" @click="request++"
              slot="activator" fab small color="primary">
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
            <span>{{ $t('menu.newRequest') }}</span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn v-if="this.permVeh.create" name="newVehicle" aria-label="New Vehicle" @click="vehicle++"
              slot="activator" fab small color="primary">
              <v-icon>mdi-car</v-icon>
            </v-btn>
            <span>{{ $t('menu.newCar') }}</span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn v-if="this.permEmployees.create" name="newEmployee" aria-label="New Employee" @click="employee++"
              slot="activator" fab small color="primary">
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
            <span>{{ $t('menu.newEmployee') }}</span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn v-if="this.permPartners.create" name="newPartner" aria-label="New Partner" @click="partner++"
              slot="activator" fab small color="primary">
              <v-icon>mdi-domain</v-icon>
            </v-btn>
            <span>{{ $t('menu.newPartner') }}</span>
          </v-tooltip>
        </v-speed-dial>
      </v-container>
    </v-content>
    <alert-snackbar :open="showAlert" :message="message"></alert-snackbar>
    <v-snackbar class="ma-3" v-if="wsOnline" v-model="snackbar" :bottom="true" :left="true" :multi-line="true"
      :timeout="0" :vertical="false">
      A new version of the app is available. Hit the refresh button to apply it !
      <v-btn color="primary" flat @click="reloadApp">
        Refresh
      </v-btn>
    </v-snackbar>
    <v-snackbar class="ma-3" v-if="status" color="warning" :value="wsOnline === false" :bottom="true" :center="true"
      :multi-line="true" :timeout="0" :vertical="false">
      You are currently not connected to the real-time server. The real-time notifications might not work !
      <v-icon class="ml-3" color="white" large>mdi-lan-disconnect</v-icon>
    </v-snackbar>
  </v-app>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapGetters
  } from "vuex";

  import moment, {
    utc,
    locale
  } from "moment";

  import {
    Howl,
    Howler
  } from 'howler';

  const NewRequest = () => import( /* webpackPrefetch: true */ "@/components/NewRequest");
  const NewPartner = () => import( /* webpackPrefetch: true */ "@/components/NewPartner");
  const NewVehicle = () => import( /* webpackPrefetch: true */ "@/components/NewVehicle");
  const NewEmployee = () => import( /* webpackPrefetch: true */ "@/components/NewEmployee");

  // const realtimeUrl = () => import('@/services/api')
  // const manager = () => import('@/services/manager')

  import {
    Workbox
  } from 'workbox-window';
  import {
    realtimeUrl
  } from "@/services/api";
  import manager from "@/services/manager";
  import realtime from "@/services/realtime";
  import AlertSnackbar from "@/components/AlertSnackbar";

  export default {
    name: "App",
    components: {
      NewRequest,
      NewPartner,
      NewVehicle,
      NewEmployee,
      AlertSnackbar
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
      if ('serviceWorker' in window.navigator) {
        this.workbox = new Workbox('/sw.js');
        this.workbox.register();

        // Add an event listener to detect when the registered
        // service worker has installed but is waiting to activate.
        this.workbox.addEventListener('waiting', function (event) {
          this.snackbar = true;
        }.bind(this));
      }

      this.$store.dispatch("hmi/setWindowSize", {
        windowSize: {
          x: window.innerWidth,
          y: window.innerHeight
        }
      });
      this.$store.dispatch("hmi/setAppDtls", {
        appDtls: {
          toolbarWidth: null,
          toolbarHeight: status ? this.$refs.mainToolbar.computedHeight : null
        }
      });
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {
      if (this.realtimeWS != null) {
        this.realtimeWS.close();
      }
    },
    props: {},
    watch: {
      status: {
        immediate: true,
        handler(newval, oldval) {
          if (newval != oldval && newval) {
            this.initWorker();

            if (this.isEmptyObj(this.userData)) {
              this.$store.dispatch("data/setUserData", {
                userData: this.info,
              });
            }

            this.globalHowler = new Howl({
              src: ['/static/audio/global.mp3'],
              volume: 1,
              preload: true,
              onend: function () {
                this.isGlobalHowling = false;
              }.bind(this)
            });

            this.dispatchHowler = new Howl({
              src: ['/static/audio/dispatch.mp3'],
              volume: 1,
              preload: true,
              onend: function () {
                this.isDispatchHowling = false;
              }.bind(this)
            });

            this.warningHowler = new Howl({
              src: ['/static/audio/warning.mp3'],
              volume: 1,
              preload: true,
              onend: function () {
                this.isWarningHowling = false;
              }.bind(this)
            });

            this.initRealtimeComm(this.token.access_token);

            manager.config(this.token);
            realtime.config(this.token);
            manager.resources
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("generic/setResources", {
                    resources: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.permissions
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("generic/setPermissions", {
                    permissions: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.equipmentsType
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("generic/setEquipmentsType", {
                    equipmentsType: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.vehiclesType
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("generic/setVehiclesType", {
                    vehiclesType: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.groups
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("data/setGroups", {
                    groups: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.requests
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("data/setRequests", {
                    requests: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.dispatches
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("data/setDispatches", {
                    dispatches: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.bundles
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("data/setBundles", {
                    bundles: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.vehicles
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("data/setVehicles", {
                    vehicles: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            manager.users
              .get()
              .then(
                function (result) {
                  this.$store.dispatch("data/setUsers", {
                    users: result.data.data
                  });
                }.bind(this)
              )
              .catch(function (err) {});

            if (this.userData.isAdmin == 1) {
              manager.users
                .myCompany(this.userData.uid)
                .then(
                  function (result) {
                    this.$store.dispatch("data/setMyCompany", {
                      myCompany: result.data.data[0]
                    });
                  }.bind(this)
                )
                .catch(function (err) {});
            }

            if (Object.keys(this.userData).length != 0) {
              manager.users
                .myPartners(this.userData.uid)
                .then(
                  function (result) {
                    this.$store.dispatch("data/setCompanies", {
                      companies: result.data.data
                    });
                  }.bind(this)
                )
                .catch(function (err) {});
            }
          } else if (newval != oldval && !newval && oldval) {
            this.destroyStorage();
            this.drawer = false;
            this.$router.push({
              name: "Login"
            });
          }
        }
      },
      token: {
        immediate: true,
        deep: true,
        handler(newval, oldval) {
          if ((newval != oldval) && (newval != null)) {
            this.$store.dispatch("data/setUserData", {
              userData: this.info,
            });
          }
        }
      },
      incomingAlert(newval, oldval) {
        if (this.currentPage != "notifications" && newval != oldval) {
          this.newAlert = true;
        }
      },
    },
    computed: {
      ...mapGetters("login", ["status", "token", "info"]),
      ...mapGetters("data", [
        "userData",
        "myCompany",
        "equipmentsType",
        "vehiclesType",
        "companies",
        "notifications",
        "requests",
        "dispatches",
        "bundles",
        "vehicles",
        "users",
        "drivers",
        "groups",
        "userSettings",
        "resources",
        "permissions",
        "permDash",
        "permTrack",
        "permNotif",
        "permReq",
        "permDispatches",
        "permVeh",
        "permEmployees",
        "permPartners"
      ]),
      ...mapGetters("generic", ["equipmentsType", "vehiclesType", "alerts", "resources", "permissions"]),
      ...mapGetters("realtime", ["position", "positions"]),
      ...mapGetters("hmi", [
        "version",
        "currentPage",
        "miniDrawer",
        "windowSize",
        "scrollPosition",
        "appDtls"
      ]),
      miniD: {
        get() {
          return this.miniDrawer;
        },
        set(value) {
          this.$store.dispatch("hmi/setMiniDrawer", {
            miniDrawer: !value
          });
        }
      },
      language() {
        return this.$i18n.locale;
      },
      menuItems() {
        let menu = [];
        menu.push({
          protected: false,
          display: true,
          avatar: this.userData.company.logo != null ? this.userData.company.logo : "/static/img/nocompany.png",
          title: this.userData.company.name,
          subtitle: this.userData.company.uid
        }, {
          protected: true,
          display: this.permDash.read || this.permTrack.read || this.permNotif.read,
          label: "",
          heading: this.$i18n.t("menu.actions")
        }, {
          protected: true,
          link: true,
          display: this.permDash.read,
          external: true,
          label: "dashboard",
          description: this.$i18n.t("menu.dashboardDesc"),
          icon: "mdi-monitor-dashboard",
          text: this.$i18n.t("menu.dashboard")
        }, {
          protected: true,
          link: true,
          display: this.permTrack.read,
          external: true,
          label: "tracking",
          description: this.$i18n.t("menu.mapsDesc"),
          icon: "mdi-map",
          text: this.$i18n.t("menu.maps")
        }, {
          protected: true,
          link: true,
          display: false,
          external: true,
          label: "notifications",
          icon: "mdi-bell",
          text: this.$i18n.t("menu.notifications")
        }, {
          protected: true,
          display: this.permReq.read || this.permDispatches.read,
          label: "",
          heading: this.$i18n.t("menu.requests")
        }, {
          protected: true,
          link: true,
          display: this.permReq.read,
          external: true,
          label: "requests",
          icon: "mdi-calendar",
          text: this.$i18n.t("menu.requests")
        }, {
          protected: true,
          link: true,
          display: this.permDispatches.read,
          external: true,
          label: "dispatches",
          icon: "mdi-headset",
          text: this.$i18n.t("menu.dispatches")
        }, {
          protected: true,
          display: false,
          label: "",
          heading: this.$i18n.t("menu.reports")
        }, {
          protected: true,
          link: true,
          display: false,
          external: true,
          label: "invoices",
          icon: "mdi-credit-card",
          text: this.$i18n.t("menu.invoice")
        }, {
          protected: true,
          display: true,
          external: true,
          label: "",
          heading: this.$i18n.t("menu.administration")
        }, {
          protected: true,
          link: true,
          display: true,
          external: true,
          label: "account",
          icon: "mdi-account",
          text: this.$i18n.t("menu.account"),
          children: []
        }, {
          protected: true,
          link: true,
          display: this.permVeh.read,
          external: true,
          label: "vehicles",
          icon: "mdi-car",
          text: this.$i18n.t("menu.vehicles")
        }, {
          protected: true,
          link: true,
          display: this.permEmployees.read,
          external: true,
          label: "employees",
          icon: "mdi-account-group",
          text: this.$i18n.t("menu.employees")
        }, {
          protected: true,
          link: true,
          display: this.permPartners.read,
          external: true,
          label: "partners",
          icon: "mdi-domain",
          text: this.$i18n.t("menu.partners")
        }, {
          protected: true,
          link: true,
          display: false,
          external: true,
          label: "settings",
          icon: "mdi-settings",
          text: this.$i18n.t("menu.settings")
        });

        return menu;
      },
      sortedAlerts() {
        return this.alerts.sort(
          this.predicate({
            name: "created",
            primer: null,
            reverse: true
          })
        );
      },
      permGroups() {
        return this.groups.filter(function (obj) {
          return obj.type == "PERMISSION";
        })
      }
    },
    methods: {
      isEmptyObj(obj) {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop))
            return false;
        }

        return JSON.stringify(obj) === JSON.stringify({});
      },
      initWorker() {
        this.etaW = this.$etaWk.create([{
          message: 'disChcOn',
          func: function (ignored, dispatches) {
            let now = new Date(),
              result = dispatches.filter(function (obj) {
                let st = obj.adjustedTimeFrom == null ? new Date(obj.timeFrom) : new Date(obj
                    .adjustedTimeFrom),
                  dur = now - st,
                  oMin = (dur > 60000) && (dur <= 120000),
                  flag = ([3, 4].indexOf(obj.status) == -1) && oMin && ignored.indexOf(obj.uid) == -1;

                return flag;
              })

            return result.map(function (obj) {
              return obj.uid;
            });
          },
        }, {
          message: 'disChcFv',
          func: function (ignored, dispatches) {
            let now = new Date(),
              result = dispatches.filter(function (obj) {
                let st = obj.adjustedTimeFrom == null ? new Date(obj.timeFrom) : new Date(obj
                    .adjustedTimeFrom),
                  dur = now - st,
                  fMin = (dur >= 300000) && (dur <= 600000),
                  flag = ([3, 4].indexOf(obj.status) == -1) && fMin && ignored.indexOf(obj.uid) == -1;

                return flag;
              })

            return result.map(function (obj) {
              return obj.uid;
            });
          },
        }, {
          message: 'disChcTen',
          func: function (ignored, dispatches, positions) {
            let now = new Date(),
              result = dispatches.filter(function (obj) {
                let st = obj.adjustedTimeFrom == null ? new Date(obj.timeFrom) : new Date(obj
                    .adjustedTimeFrom),
                  dur = st - now,
                  tMin = (dur > 0) && (dur <= 600000),
                  vehOnline = (obj.vehicleUid in positions) && ((now - new Date(positions[obj.vehicleUid]
                    .timestamp)) > 0) && ((now - new Date(positions[obj.vehicleUid]
                    .timestamp)) <= 600000),
                  flag = ([3, 4].indexOf(obj.status) == -1) && tMin && !vehOnline && ignored.indexOf(obj
                    .uid) == -1;

                return flag;
              })

            return result.map(function (obj) {
              return obj.uid;
            });
          },
        }]);

        this.routine = setInterval(this.routineFunc, 15000);
        this.wsStatus = setInterval(this.checkWSStatus, 60000);
      },
      playGlobalSound() {
        if (this.isGlobalHowling) return;
        this.isGlobalHowling = true;
        this.globalHowler.play();
      },
      playDispatchSound() {
        if (this.isDispatchHowling) return;
        this.isDispatchHowling = true;
        this.dispatchHowler.play();
      },
      playWarningSound() {
        if (this.isWarningHowling) return;
        this.isWarningHowling = true;
        this.warningHowler.play();
      },
      predicate() {
        var fields = [],
          n_fields = arguments.length,
          field,
          name,
          reverse,
          cmp;

        var default_cmp = function (a, b) {
            if (a === b) return 0;
            return a < b ? -1 : 1;
          },
          getCmpFunc = function (primer, reverse) {
            var dfc = default_cmp,
              // closer in scope
              cmp = default_cmp;
            if (primer) {
              cmp = function (a, b) {
                return dfc(primer(a), primer(b));
              };
            }
            if (reverse) {
              return function (a, b) {
                return -1 * cmp(a, b);
              };
            }
            return cmp;
          };

        // preprocess sorting options
        for (var i = 0; i < n_fields; i++) {
          field = arguments[i];
          if (typeof field === "string") {
            name = field;
            cmp = default_cmp;
          } else {
            name = field.name;
            cmp = getCmpFunc(field.primer, field.reverse);
          }
          fields.push({
            name: name,
            cmp: cmp
          });
        }

        // final comparison function
        return function (A, B) {
          var a, b, name, result;
          for (var i = 0; i < n_fields; i++) {
            result = 0;
            field = fields[i];
            name = field.name;

            result = field.cmp(A[name], B[name]);
            if (result !== 0) break;
          }
          return result;
        };
      },
      formatTime(utcTime) {
        return moment
          .utc(utcTime)
          .local()
          .format("YYYY-MM-DD HH:mm");
      },
      onScroll(e) {
        this.$store.dispatch("hmi/setScrollPosition", {
          scrollPosition: {
            x: window.pageXOffset || document.documentElement.scrollLeft,
            y: window.pageYOffset || document.documentElement.scrollTop
          }
        });
      },
      onResize() {
        this.$store.dispatch("hmi/setWindowSize", {
          windowSize: {
            x: window.innerWidth,
            y: window.innerHeight
          }
        });
      },
      toggleMiniDrawer() {
        this.$store.dispatch("hmi/setMiniDrawer", {
          miniDrawer: !this.miniDrawer
        });
      },
      execute(index) {
        switch (index) {
          case "translate":
            if (this.$i18n.locale === "fr") {
              this.$i18n.locale = "en";
            } else {
              this.$i18n.locale = "fr";
            }
            break;
          case "request":
            this.request++;
            break;
          case "logout":
            this.destroyStorage();
            this.$store.dispatch("login/signOut");
            break;
          case "notifications":
            this.newAlert = false;
          default:
            if (this.$router.currentRoute.path == `/${index}`) break;
            this.$router.push({
              path: `/${index}`
            });
            break;
        }
      },
      openInNew(label) {
        window.open(`${label}`, "_blank");
      },
      routineFunc() {
        this.etaW.postMessage('disChcOn', [this.ignored['aO'], this.dispatches.filter(function (obj) {
            return obj.status == 1;
          })])
          .then(function (result) {
            if (result.length > 0) {
              this.playWarningSound();
              Array.prototype.push.apply(this.ignored['aO'], result);
              for (let index = 0; index < result.length; index++) {
                let alert = {
                  created: moment.utc(),
                  desc: `# ${
                  result[index]
                } : the driver has at least 1 min of delay`,
                  alert: null
                };
                if (alert != null) {
                  this.$store.dispatch("generic/addAlerts", {
                    alerts: alert
                  });
                  this.incomingAlert++;
                }
              }
            }
          }.bind(this))
          .catch(console.error)
        this.etaW.postMessage('disChcFv', [this.ignored['aF'], this.dispatches.filter(function (obj) {
            return obj.status == 1;
          })])
          .then(function (result) {
            if (result.length > 0) {
              this.playWarningSound();
              Array.prototype.push.apply(this.ignored['aF'], result);
              for (let index = 0; index < result.length; index++) {
                let alert = {
                  created: moment.utc(),
                  desc: `# ${
                  result[index]
                } : the driver has at least 5 mins of delay`,
                  alert: null
                };
                if (alert != null) {
                  this.$store.dispatch("generic/addAlerts", {
                    alerts: alert
                  });
                  this.incomingAlert++;
                }
              }
            }
          }.bind(this))
          .catch(console.error)
        this.etaW.postMessage('disChcTen', [this.ignored['bT'], this.dispatches.filter(function (obj) {
            return obj.status == 1;
          }), this.position])
          .then(function (result) {
            if (result.length > 0) {
              this.playWarningSound();
              Array.prototype.push.apply(this.ignored['bT'], result);
              for (let index = 0; index < result.length; index++) {
                let alert = {
                  created: moment.utc(),
                  desc: `# ${
                  result[index]
                } : the driver has not yet accepted the call`,
                  alert: null
                };
                if (alert != null) {
                  this.$store.dispatch("generic/addAlerts", {
                    alerts: alert
                  });
                  this.incomingAlert++;
                }
              }
            }
          }.bind(this))
          .catch(console.error)
      },
      checkWSStatus() {
        let now = moment.utc();
        if ((this.realtimeWS != null) && (now.diff(this.lastPing, 'seconds') > 60)) this.realtimeWS.close();
      },
      computeAlert(alert) {
        let name = null,
          request = null,
          dispatch = null,
          bundle = null,
          desc = null,
          partnerUid = null,
          company = null,
          res = null;
        if (alert.companyUid != null) {
          if (this.userData.company.uid == alert.companyUid) {
            name = this.userData.company.name;
          } else {
            res = this.companies.filter(function (obj) {
              return obj.uid == alert.companyUid;
            });
            name = res.length > 0 ? res[0].name : "unknown";
          }
        }
        switch (alert.eventId) {
          case 1:
            switch (alert.resource) {
              case "request":
                request = this.requests.filter(function (obj) {
                  return obj.uid == alert.requestUid;
                });
                if (request.length == 0) {
                  manager.requests
                    .getByUid(alert.requestUid)
                    .then(
                      function (response) {
                        if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                            null))
                          this.$store.dispatch("data/addRequest", {
                            request: response.data.data[0]
                          });
                      }.bind(this)
                    );
                }

                this.playDispatchSound();
                return {
                  created: alert.created,
                    desc: `New service call # ${
                  alert.requestUid
                } received from ${name}`,
                    alert: alert
                };
            }
            break;
          case 2:
            switch (alert.resource) {
              case "request":
                request = this.requests.filter(function (obj) {
                  return obj.uid == alert.requestUid;
                });
                if (request.length == 0) {
                  manager.requests
                    .getByUid(alert.requestUid)
                    .then(
                      function (response) {
                        if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                            null))
                          this.$store.dispatch("data/addRequest", {
                            request: response.data.data[0]
                          });
                      }.bind(this)
                    );
                } else {
                  this.$store.dispatch("data/updateRequestByUid", {
                    uid: alert.requestUid,
                    properties: {
                      status: alert.status,
                    }
                  });
                }

                this.playGlobalSound();
                return {
                  created: alert.created,
                    desc: alert.status == 3 ? `The service call # ${alert.requestUid} has been cancelled by ${name}` :
                    `The service call # ${alert.requestUid} has been rejected by ${name}`,
                    alert: alert
                };
              case "forward":
                request = this.requests.filter(function (obj) {
                  return obj.uid == alert.requestUid;
                });
                if ((alert.companyUid != this.userData.company.uid) && (request.length == 0)) {
                  manager.requests
                    .getByUid(alert.requestUid)
                    .then(
                      function (response) {
                        if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                            null))
                          this.$store.dispatch("data/addRequest", {
                            request: response.data.data[0]
                          });
                      }.bind(this)
                    );
                } else if (request.length > 0) {
                  if ((request[0].receiverUid == alert.companyUid) && (request[0].forwarded == 0)) {
                    this.$store.dispatch("data/deleteRequestByUid", {
                      uid: alert.requestUid
                    });
                  }
                  if (request[0].forwarded == 1) {
                    var properties = request[0].receiverUid == alert.companyUid ? {
                      forwardUid: null,
                      forwarderUid: null,
                      receiverUid: null,
                      forwarded: 0
                    } : {
                      forwarded: 0
                    };

                    this.$store.dispatch("data/updateRequestByUid", {
                      uid: alert.requestUid,
                      properties: properties
                    });
                  }
                }

                this.playGlobalSound();
                return {
                  created: alert.created,
                    desc:
                    `The service call # ${alert.requestUid} has been rejected by ${name}`,
                    alert: alert
                };
              case "amend":
                request = this.requests.filter(function (obj) {
                  return obj.uid == alert.requestUid;
                });
                if (request.length == 0) {
                  manager.requests
                    .getByUid(alert.requestUid)
                    .then(
                      function (response) {
                        if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                            null))
                          this.$store.dispatch("data/addRequest", {
                            request: response.data.data[0]
                          });
                      }.bind(this)
                    );
                } else {
                  var amendDecoded = request[0].amend != null ? JSON.parse(atob(request[0].amend)).entity : null,
                    properties = {
                      amendUid: null,
                      amend: null,
                      amenderUid: null,
                    };

                  if ((amendDecoded != null) && (alert.status == 4)) {
                    if (amendDecoded.timeFrom != null) {
                      let delta = moment.utc(request[0].timeTo).diff(moment.utc(request[0].timeFrom));
                      properties.timeFrom = moment.utc(amendDecoded.timeFrom);
                      properties.timeTo = properties.timeFrom.clone().add(delta, "ms");
                      properties.timeFrom = properties.timeFrom.toISOString();
                      properties.timeTo = properties.timeTo.toISOString();
                      properties.status = 2;
                    }
                  }

                  if (alert.status == 3) {
                    this.$store.dispatch("data/deleteDispatchByUid", {
                      uid: alert.requestUid,
                    });
                  } else if (alert.status == 4) {
                    this.$store.dispatch("data/updateDispatchByUid", {
                      uid: alert.requestUid,
                      properties: {
                        status: 1
                      }
                    });
                  }

                  this.$store.dispatch("data/updateRequestByUid", {
                    uid: alert.requestUid,
                    properties: properties
                  });
                }

                this.playGlobalSound();
                return {
                  created: alert.created,
                    desc: alert.status == 3 ?
                    `The amend request for the service call # ${alert.requestUid} has been rejected` :
                    `The amend request for the service call # ${alert.requestUid} has been accepted`,
                    alert: alert
                };
              case "dispatch":
                dispatch = this.dispatches.filter(function (obj) {
                  return obj.uid == alert.requestUid;
                });
                if (dispatch.length == 0) {
                  manager.dispatches
                    .get(alert.dispatchId)
                    .then(
                      function (response) {
                        if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                            null))
                          this.$store.dispatch("data/addDispatch", {
                            request: response.data.data[0]
                          });
                      }.bind(this)
                    );
                } else {
                  var properties = {};
                  if (alert.vehicleUid != null) {
                    properties.vehicleUid = alert.vehicleUid;
                  }

                  if (alert.adjustedTimeFrom != null) {
                    properties.adjustedTimeFrom = moment.utc(alert.adjustedTimeFrom).toISOString();
                  }

                  if (alert.adjustedTimeTo != null) {
                    properties.adjustedTimeTo = moment.utc(alert.adjustedTimeTo).toISOString();
                  }

                  if (alert.status != null) {
                    properties.status = alert.status;
                  }

                  this.$store.dispatch("data/updateDispatchByUid", {
                    uid: alert.requestUid,
                    properties: properties
                  });
                }

                this.playGlobalSound();
                return {
                  created: alert.created,
                    desc: alert.status == 2 ?
                    `Dispatch for service call # ${alert.requestUid} has been rejected` :
                    `Dispatch for service call # ${alert.requestUid} has been updated`,
                    alert: alert
                };
            }
            break;
          case 3:
            switch (alert.resource) {
              case "bundle":
                bundle = this.bundles.filter(function (obj) {
                  return obj.uid == alert.bundleUid;
                });
                if (bundle.length > 0) {
                  this.$store.dispatch("data/deleteBundleByUid", {
                    uid: alert.bundleUid,
                  });
                }

                for (let ind = 0; ind < alert.requestUid.length; ind++) {
                  this.$store.dispatch("data/updateDispatchByUid", {
                    uid: alert.requestUid[ind],
                    properties: {
                      bundleUid: null,
                    }
                  });
                }

                this.playGlobalSound();
                return {
                  created: alert.created,
                    desc: `The service calls # ${alert.requestUid.join(', ')} have been unbundled !`,
                    alert: alert
                };
            }
            break;
          case 12:
            dispatch = this.dispatches.filter(function (obj) {
              return obj.id == alert.dispatchId;
            });
            if (dispatch.length == 0) {
              request = this.requests.filter(function (obj) {
                return obj.uid == alert.requestUid;
              });
              if (request.length > 0)
                this.$store.dispatch("data/updateRequest", {
                  id: request[0].id,
                  property: "status",
                  value: 2
                });
              manager.dispatches.get(alert.dispatchId).then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addDispatch", {
                      dispatch: response.data.data[0]
                    });
                }.bind(this)
              );
            }

            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `The service call # ${
              alert.requestUid
            } has been dispatched by ${name}`,
                alert: alert
            };
          case 16:
          case 17:
            let temp = alert.partnership.split(":");
            if (temp.length < 2) return;
            let isRequester = this.userData.company.uid == temp[0],
              partnerUid = isRequester ? temp[1] : temp[0],
              q = isRequester ?
              `receiverUid[eq]${partnerUid}[end]` :
              `requesterUid[eq]${partnerUid}[end]`;
            company = this.companies.filter(function (obj) {
              return obj.uid == partnerUid;
            });
            if (company.length > 0) {
              if (alert.eventId == 16) {
                desc = `New partnership request ${
                isRequester ? "sent to" : "received from"
              } ${company[0].name}`;
              } else if (alert.eventId == 17) {
                desc = `Partnership status update ${
                isRequester ? "received from" : "sent to"
              } ${company[0].name}`;
                this.$store.dispatch("data/updateCompanyStatus", {
                  uid: company[0].uid,
                  status: alert.answer != null ? alert.answer : company[0].status
                });

                if (alert.vehicleTypeIds != null) {
                  this.$store.dispatch("data/updateCompanyService", {
                    uid: company[0].uid,
                    vehicleTypeIds: alert.vehicleTypeIds.join(","),
                  });
                }
              }

              this.playGlobalSound();
              return {
                created: alert.created,
                desc: desc,
                alert: alert
              };
            }
            manager.users.myPartners(this.userData.uid, q).then(
              function (response) {
                this.$store.dispatch("data/addCompany", {
                  company: response.data.data[0]
                });
                if (alert.eventId == 16) {
                  desc = `New partnership request ${
                  isRequester ? "sent to" : "received from"
                } ${response.data.data[0].name}`;
                } else if (alert.eventId == 17) {
                  desc = `Partnership status update ${
                  isRequester ? "received from" : "sent to"
                } ${response.data.data[0].name}`;
                }
                let res = {
                  created: alert.created,
                  desc: desc,
                  alert: alert
                };
                this.$store.dispatch("generic/addAlerts", {
                  alerts: res
                });
                this.playGlobalSound();
                this.incomingAlert++;
              }.bind(this)
            );
            return null;
          case 19:
            dispatch = this.dispatches.filter(function (obj) {
              return obj.id == alert.dispatchId;
            });
            if (dispatch.length == 0) {
              manager.dispatches.get(alert.dispatchId).then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addDispatch", {
                      dispatch: response.data.data[0]
                    });
                }.bind(this)
              );
            } else {
              this.$store.dispatch("data/updateDispatch", {
                id: dispatch[0].id,
                property: "status",
                value: alert.status
              });
            }
            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `Service call # ${
              alert.requestUid
            } status : Itinerary re routed !`,
                alert: alert
            };
          case 21:
            dispatch = this.dispatches.filter(function (obj) {
              return obj.id == alert.dispatchId;
            });
            if (dispatch.length == 0) {
              manager.dispatches.get(alert.dispatchId).then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addDispatch", {
                      dispatch: response.data.data[0]
                    });
                }.bind(this)
              );
            } else {
              this.$store.dispatch("data/updateDispatch", {
                id: dispatch[0].id,
                property: "status",
                value: alert.status
              });
            }
            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `Service call # ${
              alert.requestUid
            } status : Driver en route to pick-up destination !`,
                alert: alert
            };
          case 22:
            dispatch = this.dispatches.filter(function (obj) {
              return obj.id == alert.dispatchId;
            });
            if (dispatch.length == 0) {
              manager.dispatches.get(alert.dispatchId).then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addDispatch", {
                      dispatch: response.data.data[0]
                    });
                }.bind(this)
              );
            } else {
              this.$store.dispatch("data/updateDispatch", {
                id: dispatch[0].id,
                property: "status",
                value: alert.status
              });
            }
            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `Service call # ${
              alert.requestUid
            } status : Driver en route to final destination !`,
                alert: alert
            };
          case 23:
            dispatch = this.dispatches.filter(function (obj) {
              return obj.id == alert.dispatchId;
            });
            if (dispatch.length == 0) {
              manager.dispatches.get(alert.dispatchId).then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addDispatch", {
                      dispatch: response.data.data[0]
                    });
                }.bind(this)
              );
            } else {
              this.$store.dispatch("data/updateDispatch", {
                id: dispatch[0].id,
                property: "status",
                value: alert.status
              });
            }
            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `Service call # ${
              alert.requestUid
            } status : Customer dropped off !`,
                alert: alert
            };
          case 27:
            dispatch = this.dispatches.filter(function (obj) {
              return obj.id == alert.dispatchId;
            });
            if (dispatch.length == 0) {
              manager.dispatches.get(alert.dispatchId).then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addDispatch", {
                      dispatch: response.data.data[0]
                    });
                }.bind(this)
              );
            } else {
              this.$store.dispatch("data/updateDispatch", {
                id: dispatch[0].id,
                property: "status",
                value: alert.status
              });
            }
            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `Service call # ${
              alert.requestUid
            } status : Driver arrived at pick-up point !`,
                alert: alert
            };
          case 28:
            switch (alert.resource) {
              case "dispatch":
                dispatch = this.dispatches.filter(function (obj) {
                  return obj.id == alert.dispatchId;
                });
                if (dispatch.length == 0) {
                  manager.dispatches.get(alert.dispatchId).then(
                    function (response) {
                      if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                          null))
                        this.$store.dispatch("data/addDispatch", {
                          dispatch: response.data.data[0]
                        });
                    }.bind(this)
                  );
                } else {
                  this.$store.dispatch("data/updateDispatch", {
                    id: dispatch[0].id,
                    property: "status",
                    value: alert.status
                  });
                }
                request = this.requests.filter(function (obj) {
                  return obj.uid == alert.requestUid;
                });
                if (request.length > 0)
                  this.$store.dispatch("data/updateRequest", {
                    id: request[0].id,
                    property: "status",
                    value: 6
                  });

                this.playGlobalSound();
                return {
                  created: alert.created,
                    desc: `The service call # ${
                  alert.requestUid
                } has been completed by ${name}`,
                    alert: alert
                };
            }
            break;
          case 29:
            var sender = null,
              senderName = null,
              receiverName = null;
            if (this.userData.company.uid == alert.requesterUid) {
              senderName = this.userData.company.name;
              sender = true;
            } else {
              res = this.companies.filter(function (obj) {
                return obj.uid == alert.requesterUid;
              });
              senderName = res.length > 0 ? res[0].name : "unknown";
            }
            if (this.userData.company.uid == alert.receiverUid) {
              receiverName = this.userData.company.name;
              sender = false;
            } else {
              res = this.companies.filter(function (obj) {
                return obj.uid == alert.receiverUid;
              });
              receiverName = res.length > 0 ? res[0].name : "unknown";
            }
            request = this.requests.filter(function (obj) {
              return obj.uid == alert.requestUid;
            });
            if (request.length == 0) {
              manager.requests
                .getByUid(alert.requestUid)
                .then(
                  function (response) {
                    if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                        null))
                      this.$store.dispatch("data/addRequest", {
                        request: response.data.data[0]
                      });
                  }.bind(this)
                );
            } else {
              var properties = request[0].forwardUid == null ? {
                forwardUid: alert.uid,
                forwarderUid: alert.requesterUid,
                receiverUid: alert.receiverUid,
                forwarded: 0
              } : {
                forwarded: 1
              };

              this.$store.dispatch("data/updateRequestByUid", {
                uid: alert.requestUid,
                properties: properties
              });
            }

            this.playGlobalSound();
            return {
              created: alert.created,
                desc: sender ?
                `The service call # ${
                  alert.requestUid
                } has been forwarded to ${receiverName}` :
                `New service call # ${
                  alert.requestUid
                } received from ${senderName}`,
                alert: alert
            };
            break;
          case 30:
            request = this.requests.filter(function (obj) {
              return obj.uid == alert.requestUid;
            });
            if (request.length == 0) {
              manager.requests
                .getByUid(alert.requestUid)
                .then(
                  function (response) {
                    if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                        null))
                      this.$store.dispatch("data/addRequest", {
                        request: response.data.data[0]
                      });
                  }.bind(this)
                );
            } else {
              this.$store.dispatch("data/updateRequestByUid", {
                uid: alert.requestUid,
                properties: {
                  amendUid: alert.amendUid,
                  amenderUid: alert.companyUid,
                  amend: alert.amend,
                }
              });
            }

            if (alert.dispatchId != null) {
              manager.dispatches
                .get(alert.dispatchId)
                .then(
                  function (response) {
                    if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                        null))
                      this.$store.dispatch("data/addDispatch", {
                        dispatch: response.data.data[0]
                      });
                  }.bind(this)
                );
            }

            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `The service call # ${
                  alert.requestUid
                } has been amended`,
                alert: alert
            };
            break;
          case 31:
            for (let ind = 0; ind < alert.requestUid.length; ind++) {
              dispatch = this.dispatches.filter(function (obj) {
                return obj.uid == alert.requestUid[ind];
              });
              if (dispatch.length == 0) {
                // manager.dispatches
                //   .get(null, `bundleUid=${alert.bundleUid}[and]requestUid=${alert.requestUid[ind]}`)
                //   .then(
                //     function (response) {
                //       if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                //           null))
                //         this.$store.dispatch("data/addDispatch", {
                //           request: response.data.data[0]
                //         });
                //     }.bind(this)
                //   );
              } else {
                this.$store.dispatch("data/updateDispatchByUid", {
                  uid: alert.requestUid[ind],
                  properties: {
                    bundleUid: alert.bundleUid,
                  }
                });
              }
            }

            bundle = this.bundles.filter(function (obj) {
              return obj.uid == alert.bundleUid;
            });
            if (bundle.length == 0) {
              manager.bundles
                .get(alert.bundleUid)
                .then(
                  function (response) {
                    if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                        null))
                      this.$store.dispatch("data/addBundle", {
                        bundle: response.data.data[0]
                      });
                  }.bind(this)
                )
            } else {
              this.$store.dispatch("data/updateBundleByUid", {
                uid: alert.bundleUid,
                properties: {
                  requestUid: alert.requestUid.join(', '),
                }
              });
            }

            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `The service calls # ${
                  alert.requestUid.join(', ')
                } have been bundled`,
                alert: alert
            };
            break;
          case 33:
            manager.requests
              .getSchedules(alert.scheduleUid)
              .then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addRequests", {
                      requests: response.data.data
                    });
                }.bind(this)
              )

            manager.dispatches
              .getSchedules(alert.scheduleUid)
              .then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addDispatches", {
                      dispatches: response.data.data
                    });
                }.bind(this)
              )

            this.playGlobalSound();
            return {
              created: alert.created,
                desc: `The service calls # ${alert.requestUid} have been scheduled`,
                alert: alert
            };
            break;
          case 34:
            manager.requests
              .getByUid(alert.roundTripUid)
              .then(
                function (response) {
                  if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                      null))
                    this.$store.dispatch("data/addRequest", {
                      request: response.data.data[0]
                    });
                }.bind(this)
              );

            manager.dispatches.get(alert.dispatchId).then(
              function (response) {
                if ((response.data.data != null) && (response.data.data.length > 0) && (response.data.data[0] !=
                    null))
                  this.$store.dispatch("data/addDispatch", {
                    dispatch: response.data.data[0]
                  });
              }.bind(this)
            );

            this.playGlobalSound();
            return {
              created: alert.created,
                desc:
                `The roundtrip for the service # ${alert.requestUid} have been successfully created and dispatched`,
                alert: alert
            };
            break;
        }
      },
      reloadApp() {
        this.snackbar = false;
        this.workbox.addEventListener('controlling', (event) => {
          window.location.reload();
        });

        // Send a message telling the service worker to skip waiting.
        // This will trigger the `controlling` event handler above.
        // Note: for this to work, you have to add a message
        // listener in your service worker. See below.
        this.workbox.messageSW({
          type: 'SKIP_WAITING'
        });
      },
      initRealtimeComm(token) {
        let url = `${realtimeUrl}`;
        this.realtimeWS = new WebSocket(url);
        this.realtimeWS.onopen = this.onRealtimeCommOpen;
        this.realtimeWS.onclose = this.onRealtimeCommClose;
        this.realtimeWS.onmessage = this.onRealtimeCommMessage;
        this.realtimeWS.onerror = this.onRealtimeCommError;
      },
      onRealtimeCommOpen(e) {},
      onRealtimeCommClose(e) {
        this.wsOnline = false;
        if (this.failed) {
          this.destroyStorage();
          this.$store.dispatch("login/signOut");
          return;
        }
        if (this.token != null)
          setTimeout(this.initRealtimeComm, 5000, this.token.access_token);
      },
      onRealtimeCommMessage(e) {
        try {
          let msg = JSON.parse(e.data);
          switch (msg.cmd) {
            case "ETA-AUTH":
              if (msg.status != null) {
                if (msg.status == "CLOSING") {
                  this.failed = true;
                  break;
                }
                if (msg.status == "SUCCEED") {
                  this.wsOnline = true;
                  this.$store.dispatch("realtime/updatePositions", {
                    position: msg.positions
                  });
                  break;
                }
                this.realtimeWS.send(
                  JSON.stringify({
                    cmd: "ETA-AUTH",
                    data: {
                      token: this.token.access_token,
                      type: "ETA-DESKTOP"
                    }
                  })
                );
              }
              break;
            case "ETA-MGR-NOTIF":
              let alert = this.computeAlert(msg.data);
              if (alert != null) {
                this.$store.dispatch("generic/addAlerts", {
                  alerts: alert
                });
                this.incomingAlert++;
              }
              break;
            case "ETA-VEH-EVNT":
              // if (msg.data.eventId != null) {
              //   let alert = this.computeAlert(msg.data);
              //   if (alert != null) {
              //     this.$store.dispatch("generic/addAlerts", {
              //       alerts: alert
              //     });
              //     this.incomingAlert++;
              //   }
              // }
            case "ETA-VEH-POS":
              this.$store.dispatch("realtime/updatePositions", {
                position: msg.data
              });
              break;
            case "ETA-PING":
              this.realtimeWS.send(
                JSON.stringify({
                  cmd: "ETA-PONG",
                  data: null
                })
              );
              this.lastPing = moment.utc();
              break;
            case "ETA_EMP_STATUS":
              this.$store.dispatch("realtime/updateStatuses", {
                status: msg.data
              });
              break;
          }
        } catch (error) {}
      },
      onRealtimeCommError(e) {
        console.error("error");
        console.error(e);
      },
      destroyStorage() {
        if (this.realtimeWS != null) this.realtimeWS.close();
        if (this.routine != null) {
          clearInterval(this.routine);
          this.routine = null;
        }
        if (this.wsStatus != null) {
          clearInterval(this.wsStatus);
          this.wsStatus = null;
        }
        this.etaW = null;

        if (this.token != null) {
          manager
            .logout()
            .then(function (result) {}.bind(this))
            .catch(function (err) {}.bind(this));
        }
        manager.config(null);

        this.$store.dispatch("data/destroyStorage");
        this.$store.dispatch("generic/destroyStorage");
        this.$store.dispatch("realtime/destroyStorage");
      }
    },
    data() {
      return {
        v: "0.00.1",
        routine: null,
        workbox: null,
        snackbar: false,
        isDispatchHowling: false,
        isGlobalHowling: false,
        isWarningHowling: false,
        dispatchHowler: null,
        globalHowler: null,
        warningHowler: null,
        wsOnline: null,
        failed: false,
        drawer: false,
        fab: false,
        request: 0,
        partner: 0,
        vehicle: 0,
        employee: 0,
        newAlert: false,
        incomingAlert: 0,
        realtimeWS: null,
        widgets: false,
        showAlert: 0,
        message: "",
        etaW: null,
        lastPing: moment.utc(),
        wsStatus: null,
        ignored: {
          aO: [],
          aF: [],
          bT: [],
        },
      };
    },
    // Idle Vue
    onIdle() {
      if (this.token != null) {
        this.execute("logout");
      }
    },
    onActive() {},
    // `i18n` option
    i18n: {
      messages: {
        en: {
          menu: {
            actions: "Actions",
            dashboard: "Dashboard",
            dashboardDesc: "Display the data your way",
            maps: "Real-time tracking",
            mapsDesc: "Follow up what is happening on the map",
            notifications: "Notifications",
            requests: "Service calls",
            newRequest: "New service call",
            newCar: "New car",
            newEmployee: "New employee",
            newPartner: "New Partner",
            dispatches: "Dispatch center",
            reports: "Reports",
            invoice: "Invoices",
            administration: "Administration",
            account: "Account",
            settings: "Settings",
            vehicles: "Vehicles",
            employees: "Employees",
            partners: "Partners"
          }
        },
        fr: {
          menu: {
            actions: "Actions",
            dashboard: "Tableau de bord",
            maps: "Suivi à temps réel",
            notifications: "Notifications",
            requests: "Appels de service",
            newRequest: "Nouveau appel de service",
            newCar: "Nouveau véhicule",
            newEmployee: "Nouvel employé",
            newPartner: "Nouveau partenaire",
            dispatches: "Centre de répartitions",
            reports: "Rapports",
            invoice: "Factures",
            administration: "Administration",
            account: "Compte utilisateur",
            settings: "Paramètres",
            vehicles: "Véhicules",
            employees: "Employés",
            partners: "Partenaires"
          }
        }
      }
    }
  };

</script>

<style>
  .active-call {
    background-color: rgb(76, 175, 80) !important;
    caret-color: rgb(76, 175, 80) !important;
    border-color: rgb(76, 175, 80) !important;
  }

</style>
